import { AxiosResponse } from "axios";
import apiClient from "../apiClient/apiClient";
import { useQuery } from 'react-query';
import { Criteria } from "./criteria.types";


export const useCriteria = () => {
    return useQuery<AxiosResponse<Criteria[]>>('criteria', () => apiClient.get<Criteria[]>('/criterias'))
}